// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"a878a8ee","453":"23e117ad"}[chunkId] + ".chunk.js";
};